import React, {Component, Fragment} from 'react';

import classNames from 'classnames';
import {generateId} from '../../shared/utils';
import i18n from '../../shared/i18n/i18n';

import days from './days.json';
import hours from './hours.json';

import FieldSelect from '../../SharedComponent/FieldSelect/FieldSelect';
import FieldMultilingualSelect from "../FieldMultilingualSelect/FieldMultilingualSelect";

export default class FieldDateTime extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: this.props.option.value || '',
            error: this.props.option.error || '',
            enabledError: this.props.option.enabledError !== false,
        };

        this.ui = {
            day: React.createRef(),
            month: React.createRef(),
            year: React.createRef(),
            hours: React.createRef(),
            minutes: React.createRef(),
        };

        this.yearGenerator = this.yearGenerator.bind(this);
        this.onCheckDate = this.onCheckDate.bind(this);
        this.getValue = this.getValue.bind(this);
        this.setValue = this.setValue.bind(this);
        this.checkDate = this.checkDate.bind(this);
        this.setError = this.setError.bind(this);
    }

    yearGenerator() {
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 80;
        const maxYear = currentYear;
        let yearValues = [];

        for (let i = maxYear; i >= minYear; i--) {
            yearValues.push({
                id: i,
                name: i.toString(),
            });
        }

        return yearValues;
    }

    onCheckDate(value, type) {
        let day = parseInt(this.ui.day.current.getValue());
        let month = parseInt(this.ui.month.current.getValue());
        let year = parseInt(this.ui.year.current.getValue());

        switch (type) {
            case 'day':
                day = parseInt(value);
                break;
            case 'month':
                month = parseInt(value);
                break;
            case 'year':
                year = parseInt(value);
                break;
        }

        this.setState({error: this.checkDate(day, month, year) ? '' : 'NOTE_INVALID_DATE'});
    }

    checkDate(day, month, year) {
        if (day === 0 || month === 0 || year === 0) return true;

        let date = new Date(year, month - 1, day);
        return date.getDate() === day && date.getMonth() === month - 1 && date.getFullYear() === year;
    }

    setValue(value) {
        this.setState({error: ''});

        if (value.length === 0) {
            this.ui.day.current && this.ui.day.current.setValue(0);
            this.ui.month.current && this.ui.month.current.setValue(0);
            this.ui.year.current && this.ui.year.current.setValue(0);
            this.ui.hours.current && this.ui.hours.current.setValue(0);
            this.ui.minutes.current && this.ui.minutes.current.setValue(0);
            return;
        }

        let datetime = value.split(' ');

        let date = datetime[0].split('-');

        let day = parseInt(date[2]);
        let month = parseInt(date[1]);
        let year = parseInt(date[0]);

        this.ui.day.current.setValue(day);
        this.ui.month.current.setValue(month);
        this.ui.year.current.setValue(year);
        if (this.props.option.hasTime === true) {
            let time = datetime[1].split(':');

            let hours = parseInt(time[0]);
            let minutes = parseInt(time[1]);

            this.ui.hours.current.setValue(hours);
            this.ui.minutes.current.setValue(minutes);
        }
    }

    getValue() {
        let day = parseInt(this.ui.day.current.getValue());
        let month = parseInt(this.ui.month.current.getValue());
        let year = parseInt(this.ui.year.current.getValue());

        if (day === 0 || month === 0 || year === 0) return '';

        if (!this.checkDate(day, month, year)) return '';

        let d = new Date(year, month - 1, day);
        let dateString = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
        let timeString = '';
        if (this.props.option.hasTime === true) {
            let hours = parseInt(this.ui.hours.current.getValue());
            let minutes = parseInt(this.ui.minutes.current.getValue());
            timeString = ' ' + ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':00';
        }
        return dateString + timeString;
    }

    setError(error = '') {
        if (this.state.enabledError) this.setState({error});
    }

    render() {

        return (
            <div className='fb-col field-wrap'>
                <div className="fb-row fb-sb-c">
                    {this.props.option.label &&
                    <label htmlFor={this.labelId} className="label">{i18n(this.props.option.label, this.props.setting.lang)}</label>
                    }
                </div>
                <div className={classNames(this.state.error.length === 0 && 'invisible', 'error')}>{i18n(this.state.error, this.props.setting.lang)}&nbsp;</div>
                <div className={classNames("fb-row", this.state.error.length === 0 ? '' : 'error-border')}>
                    <FieldSelect ref={this.ui.day} setting={this.props.setting} option={{
                        preData: [{id: 0, name: "DAY", disabled: true}],
                        data: days,
                        onChange: (value) => {
                            this.onCheckDate(value, 'day');
                            return true;
                        },
                        className: 'p0',
                        enabledError: false,
                    }}/>
                    <FieldMultilingualSelect ref={this.ui.month} setting={this.props.setting} option={{
                        preData: [{id: 0, name: "MONTH", disabled: true}],
                        data: [
                            {
                                id: 1,
                                name: {
                                    'ru': i18n('JANUARY', 'ru'),
                                    'en': i18n('JANUARY', 'en'),
                                },
                            },
                            {
                                id: 2,
                                name: {
                                    'ru': i18n('FEBRUARY', 'ru'),
                                    'en': i18n('FEBRUARY', 'en'),
                                },
                            },
                            {
                                id: 3,
                                name: {
                                    'ru': i18n('MARCH', 'ru'),
                                    'en': i18n('MARCH', 'en'),
                                },
                            },
                            {
                                id: 4,
                                name: {
                                    'ru': i18n('APRIL', 'ru'),
                                    'en': i18n('APRIL', 'en'),
                                },
                            },
                            {
                                id: 5,
                                name: {
                                    'ru': i18n('MAY', 'ru'),
                                    'en': i18n('MAY', 'en'),
                                },
                            },
                            {
                                id: 6,
                                name: {
                                    'ru': i18n('JUNE', 'ru'),
                                    'en': i18n('JUNE', 'en'),
                                },
                            },
                            {
                                id: 7,
                                name: {
                                    'ru': i18n('JULY', 'ru'),
                                    'en': i18n('JULY', 'en'),
                                },
                            },
                            {
                                id: 8,
                                name: {
                                    'ru': i18n('AUGUST', 'ru'),
                                    'en': i18n('AUGUST', 'en'),
                                },
                            },
                            {
                                id: 9,
                                name: {
                                    'ru': i18n('SEPTEMBER', 'ru'),
                                    'en': i18n('SEPTEMBER', 'en'),
                                },
                            },
                            {
                                id: 10,
                                name: {
                                    'ru': i18n('OCTOBER', 'ru'),
                                    'en': i18n('OCTOBER', 'en'),
                                },
                            },
                            {
                                id: 11,
                                name: {
                                    'ru': i18n('NOVEMBER', 'ru'),
                                    'en': i18n('NOVEMBER', 'en'),
                                },
                            },
                            {
                                id: 12,
                                name: {
                                    'ru': i18n('DECEMBER', 'ru'),
                                    'en': i18n('DECEMBER', 'en'),
                                },
                            },
                        ],
                        onChange: (value) => {
                            this.onCheckDate(value, 'month');
                            return true;
                        },
                        className: 'p0',
                        enabledError: false,
                    }}/>
                    <FieldSelect ref={this.ui.year} setting={this.props.setting} option={{
                        preData: [{id: 0, name: "YEAR", disabled: true}],
                        data: this.yearGenerator(),
                        onChange: (value) => {
                            this.onCheckDate(value, 'year');
                            return true;
                        },
                        className: 'p0',
                        enabledError: false,
                    }}/>
                    {this.props.option.hasTime &&
                    <div className='m01rem fb-row'>
                        <FieldSelect ref={this.ui.hours} setting={this.props.setting} option={{
                            data: hours,
                            className: 'p0',
                            enabledError: false,
                        }}/>
                        <FieldSelect ref={this.ui.minutes} setting={this.props.setting} option={{
                            data: [
                                {
                                    id: 0,
                                    name: '00',
                                },
                                {
                                    id: 30,
                                    name: '30',
                                },
                            ],
                            className: 'p0',
                            enabledError: false,
                        }}/>
                    </div>
                    }

                </div>
            </div>
        );
    }

}